import { render, staticRenderFns } from "./transfer_protocol.vue?vue&type=template&id=7b6985da"
import script from "./transfer_protocol.vue?vue&type=script&lang=js"
export * from "./transfer_protocol.vue?vue&type=script&lang=js"
import style0 from "./transfer_protocol.vue?vue&type=style&index=0&id=7b6985da&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports